import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ApiGautrainConstants } from "../../constants/api-constants/api-gautrain.constants";
let GautrainService = class GautrainService {
    http;
    constructor(http) {
        this.http = http;
    }
    getApplicationSetZonesObservable(applicationId, params) {
        return this.http
            .post(`${ApiGautrainConstants}/${applicationId}/${ApiGautrainConstants.FUNCTION_SET_ZONES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    getApplicationSetApplicationTypesObservable(applicationId, params) {
        return this.http.post(`${ApiGautrainConstants.URL}/${applicationId}/${ApiGautrainConstants.FUNCTION_SET_APPLICATION_TYPES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiGautrainConstants.URL}/${applicationId}/${ApiGautrainConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
GautrainService = __decorate([
    Injectable({
        providedIn: "root"
    })
], GautrainService);
export { GautrainService };
